import { lazyLoad } from 'utils/loadable';

export const Seo = lazyLoad(
  () => import('./index'),
  module => module.Seo,
);
